/*************************************************************
 * NotificationContainer.js - Notification display component
 *************************************************************/

export const NotificationContainer = ({ notifications, onRemove }) => {
    if (!notifications || notifications.length === 0) return null;

    return (
        <div 
            className="position-fixed" 
            style={{
                top: '20px',
                right: '20px',
                zIndex: 9999,
                minWidth: '300px'
            }}
        >
            {notifications.map(notification => (
                <div
                    key={notification.id}
                    className={`alert alert-${notification.type} alert-dismissible fade show mb-2 shadow`}
                    role="alert"
                >
                    <div className="d-flex align-items-center">
                        <i className={`fas fa-${
                            notification.type === 'success' ? 'check-circle' :
                            notification.type === 'danger' ? 'exclamation-circle' :
                            notification.type === 'warning' ? 'exclamation-triangle' :
                            'info-circle'
                        } mr-2`}></i>
                        <span className="flex-grow-1">{notification.message}</span>
                        <button
                            type="button"
                            className="btn btn-sm p-0 ml-2"
                            onClick={() => onRemove(notification.id)}
                            style={{ background: 'none', border: 'none', color: 'inherit' }}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
};